import React from "react"

import { Star } from "../../../../utils/IconsList"
import Button from "../../../Button"
import { packageColors } from "../../../Hero/HeroPackaging/components/PackageCard"
import {
  HeaderCellTitle,
  HeaderCellSubtitle,
  StarWrap,
} from "../../styles/TableCell.styled"

const HeaderPackage = ({ title, subtitle, color, stars, cta }) => {
  const packageColor = packageColors[color?.toLowerCase()]

  return (
    <>
      {title && <HeaderCellTitle>{title}</HeaderCellTitle>}
      {subtitle && <HeaderCellSubtitle>{subtitle}</HeaderCellSubtitle>}
      {stars && (
        <StarWrap color={packageColor}>{Array(stars).fill(<Star />)}</StarWrap>
      )}
      {cta && (
        <Button
          isWithArrow
          link={cta?.url}
          variant="text-link"
          className="header-cta"
        >
          {cta?.label}
        </Button>
      )}
    </>
  )
}

export default HeaderPackage
